/* eslint-disable multiline-ternary */
/* eslint-disable no-mixed-operators */
import { yupResolver } from '@hookform/resolvers/yup'
import moment from 'moment/moment'
import {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
} from 'reactstrap'
import { InputNumber } from '../../../components/inputs'
import { filtrarTiposDeVenta } from '../../../../utility/utils'
import { setInitialData } from '../store'
import { ProductSchema } from './validations'
import { departmentsOptions } from '../db/departments'
import { municipalityOptions } from '../db/municipalities'
import { economicActivity } from '../db/economicActivity'
import toast from 'react-hot-toast'
import { producTypesdb } from '../db/producTypes'
import SearchInput from './searchInput'
import { productServicedb } from '../../product-services-master/fake-data'
import {
  checkIfUserExists,
  getData,
} from '../../product-services-master/store'
import { useParams } from 'react-router-dom'
import {
  createProducts,
  updateProduct,
} from '../../product-services-master/thunks'
import CurrencyInput from 'react-currency-input-field'

// import InputEmail from '../../../components/inputs'

const initialFilterProps = {
  clientCode: '',
  codeType: '',
  dteType: '',
  company: '',
  receiverEmail: '',
  receiverPhoneNumber: '',
  receiverName: '',
  startDate: moment().subtract(1, 'day'),
  endDate: null,
  productName: '',
  productCode: '',
  quantity: '',
  unitOfMeasure: null,
  TypeOfSale: null,
  discount: '',
}

const CreateProductsForm = forwardRef(
  ({ filteredData, setFilteredData }, ref) => {
    const [filterProps, setFilterProps] = useState(initialFilterProps)
    const [areaFilterValue, setAreaFilterValue] = useState(null)
    const dispatch = useDispatch()
    const { isPending } = useSelector((state) => state.transactions)
    const { data } = useSelector((state) => state.productServiceMaster)
    const { products } = useSelector((state) => state.invoiceIssuance)
    const invoiceIssuance = useSelector((state) => state.invoiceIssuance)

    const [nameValue, setNameValue] = useState('')
    const [isEdited, setIsEdited] = useState(false)

    const { invoiceId } = useParams()

    const userInfo = useSelector((state) => state.businessManager)
    const {
      receptor,
      measurementUnits,
      saleTypes,
      relatedDoc,
      offerTypes,
    } = useSelector((state) => state.invoiceIssuance)

    // useForm
    const {
      handleSubmit,
      control,
      reset,
      setValue,
      watch,
      getValues,
      setError,
      formState: { errors },
    } = useForm({
      defaultValues: {
        ...initialFilterProps,
      },
      mode: 'all',
      reValidateMode: 'onChange',
      resolver: yupResolver(ProductSchema),
    })

    useImperativeHandle(ref, () => ({
      resetProductForm: () => {
        reset() // Reset the form
        setIsEdited(false)
      },
    }))

    let activeProducts = (
      invoiceId === 'note' || invoiceId === 'debit-note' ? products : data
    )?.filter?.((product) => product.isActive)

    if (!activeProducts) {
      activeProducts = []
    }

    const filteredOptions = producTypesdb.filter((option) => {
      if (userInfo?.data?.typeOffer?.value === '01') {
        setValue('prodType', { value: '01', label: 'Producto' })
        activeProducts = activeProducts.filter(
          (product) => product.prodType.value === 'Producto'
        )

        return option.value === '01'
      }
      if (userInfo?.data?.typeOffer?.value === '02') {
        setValue('prodType', { value: '02', label: 'Servicio' })
        activeProducts = activeProducts.filter(
          (product) => product.prodType.value === 'Servicio'
        )

        return option.value === '02'
      }

      return true
    })

    const isExempt = receptor?.dteType?.value === '11'

    const handleClearFilters = () => {
      setFilterProps(initialFilterProps)
      setAreaFilterValue(null)
      dispatch(setInitialData())
      reset()
    }

    const handleSetProductService = async () => {
      const submitData = getValues()

      const requiredFields = [
        'prodType',
        'price',
        'productCode',
        'productName',
      ]
      let hasError = false

      requiredFields.forEach((field) => {
        if (!submitData[field]) {
          setError(field, {
            type: 'manual',
            message: 'Este campo es obligatorio',
          })
          hasError = true
        }
      })

      if (hasError) {
        toast.error('Debe completar los campos')
        return
      }

      const baseInfo = {
        ...submitData,
        quantity: 1,
        prodTypeId:
          submitData.prodType?.value === 'Producto' ? 1076 : 1077,
        unitOfMeasureId: submitData.unitOfMeasure.id,
        typeOfSale: 'retail',
        discount: 1.0,
        accept: true,
        description: '',
        isActive: true,
      }

      if (isEdited) {
        const storeUser = data.find(
          (client) => client.productCode === submitData.productCode
        )
        dispatch(updateProduct({ ...storeUser, ...baseInfo }))
        // dispatch(editUserAction(result))
        toast.success('Registro Editado')
      } else if (
        submitData.prodType &&
        submitData.price &&
        submitData.productCode &&
        submitData.productName
      ) {
        if (checkIfUserExists(submitData.productCode)) {
          //toast.error("Ya existe un registro con este código");
          return
        } else {
          //dispatch(addUserAction(submitData))
        }

        dispatch(createProducts(baseInfo))

        toast.success('Registro creado')
        setIsEdited(true)
      } else {
        toast.error('Debe completar los campos')
      }
    }

    const handleClear = () => {
      reset({
        prodType: '',
        productCode: '',
        productName: '',
        quantity: '',
        unitOfMeasure: '',
        TypeOfSale: null,
        price: '',
        discount: '',
      })

      setIsEdited(false)
    }

    const onSubmit = (data) => {
      if (
        (invoiceId === 'note' || invoiceId === 'debit-note') &&
        !relatedDoc
      ) {
        return toast.error(
          'Por favor, seleccione un documento relacionado.'
        )
      }
      const auxData = { ...data }

      auxData.discount = data.discount ? data.discount : 0

      console.log('filteredData: ', filteredData)

      const existingProductIndex = filteredData?.findIndex(
        (item) => item.productCode === data.productCode
      )

      if (existingProductIndex !== -1 && data.productCode) {
        // Si el producto ya existe, clona el objeto existente para evitar la mutación directa
        const existingProduct = { ...filteredData[existingProductIndex] }

        // El descuento se guarda como PORCENTAJE en el ítem, pero lo que hay
        // que conservar al fusionar es el DINERO rebajado: la Normativa no
        // tiene un porcentaje por ítem (el #134 es global y opcional), solo el
        // monto del #89. Antes se promediaban los dos porcentajes, lo que
        // ignoraba las cantidades y se acumulaba en cascada: 1u al 0% + 1u al
        // 50% + 3u al 0% daba 12.5% y $875 gravados donde correspondían $900.
        const dineroExistente =
          (Number(existingProduct.price) *
            Number(existingProduct.discount || 0)) /
          100 *
          Number(existingProduct.quantity)
        const dineroNuevo =
          (Number(auxData.price) * Number(auxData.discount || 0)) /
          100 *
          Number(auxData.quantity)

        // Actualiza la cantidad
        existingProduct.quantity += Number(auxData.quantity)

        // Porcentaje equivalente sobre la línea ya fusionada, de modo que
        // precio * % * cantidad vuelva a dar el dinero rebajado total
        const baseFusionada =
          Number(existingProduct.price) * Number(existingProduct.quantity)
        existingProduct.discount =
          baseFusionada > 0
            ? Number(
                (
                  ((dineroExistente + dineroNuevo) * 100) /
                  baseFusionada
                ).toFixed(4)
              )
            : 0

        // Recalcula el subtotal
        const total = baseFusionada
        const appliesTaxes = isExempt ? 0 : 0.13
        existingProduct.subtotal =
          total -
          (total * existingProduct.discount) / 100 +
          total * appliesTaxes
        // Crea una nueva lista de productos con el producto actualizado
        const updatedData = [...filteredData]
        updatedData[existingProductIndex] = existingProduct

        // Actualiza el estado
        setFilteredData(updatedData)

        toast.success('Cantidad actualizada')
      } else {
        // Si el producto no existe, agrégalo como nuevo
        const total = auxData.price * auxData.quantity
        const appliesTaxes = 0.13
        const totalDiscount = (total * auxData.discount) / 100
        auxData.subtotal =
          total -
          total * (auxData.discount / 100) +
          (total - totalDiscount) * appliesTaxes
        auxData.id = filteredData.length + 1
        //auxData.productCode = isEdited ? data.productCode : '';
        auxData.productCode = data.productCode

        setFilteredData([...filteredData, auxData])

        toast.success('Item Añadido')
      }
    }

    const consultOnce = useRef(1)

    const handleInputChange = (newValue, field) => {
      const inputValue = newValue.replace(/\D/g, '') // Permite solo números
      field.onChange(inputValue) // Actualiza el valor del campo 'NIT'
    }

    const enterCustomerFound = (Client) => {
      setValue('productCode', Client.productCode)
      setValue('productName', Client.productName)
      setValue('unitOfMeasure', Client.unitOfMeasure)

      setValue('prodType', Client.prodType)
      setValue('price', Client.price)
      setValue('company', Client.company)
      setValue('receiverEmail', Client.receiverEmail)
      setValue('receiverPhoneNumber', Client.receiverPhoneNumber)
      setNameValue(Client.receiverName)
      setValue('receiverName', Client.receiverName)
      setValue('tradeName', Client.tradeName)
      setValue('NIT', Client.NIT)
      //setNITValue(Client.NIT)
      const departmentValue = departmentsOptions.find(
        (option) => option.value === Client?.department?.value
      )
      const municipalityValue = municipalityOptions.find(
        (option) => option.value === Client?.municipality?.value
      )
      const economicActivityValue = economicActivity.find(
        (option) => option.value === Client?.EconomicActivity?.value
      )
      setValue('department', departmentValue)
      setValue('municipality', municipalityValue)
      setValue('EconomicActivity', economicActivityValue)
      setValue('address', Client.address)
      setIsEdited(true)
    }
    useEffect(() => {
      dispatch(getData({}))
    }, [])
    return (
      <Fragment>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
              <CardTitle tag="h4">Agregar productos o servicios</CardTitle>
            </CardHeader>

            <Row
              className="mx-0"
              style={{ paddingTop: '2%', paddingLeft: '5%' }}
            >
              <Col>
                <Label className="me-1">Tipo de producto*</Label>
                <Controller
                  name="prodType"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        options={filteredOptions}
                      />
                      {errors.prodType && (
                        <FormFeedback className="d-block">
                          {errors.prodType.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>

              <Col>
                <SearchInput
                  itemList={productServicedb}
                  label={'Código de producto/servicio'}
                  defaultvalueInput={nameValue}
                  errors={errors}
                  control={control}
                  action={enterCustomerFound}
                  searchType={'productCode'}
                  itemType={'product'}
                  database={
                    /*invoiceId === 'note' ? products : data*/ activeProducts
                  }
                  disabled={isEdited}
                  options={{
                    id: 'productCode',
                    name: 'productCode',
                  }}
                />
              </Col>
              <Col>
                <SearchInput
                  itemList={productServicedb}
                  label={'Nombre de producto/servicio*'}
                  defaultvalueInput={nameValue}
                  errors={errors}
                  control={control}
                  action={enterCustomerFound}
                  searchType={'productName'}
                  itemType={'product'}
                  database={
                    /*invoiceId === 'note' ? products : data*/ activeProducts
                  }
                  options={{
                    id: 'productName',
                    name: 'productName',
                  }}
                />
              </Col>
            </Row>
            <Row
              className="mx-0"
              style={{ paddingTop: '2%', paddingLeft: '5%' }}
            >
              <Col>
                <InputNumber
                  label={'Cantidad*'}
                  errors={errors}
                  control={control}
                  options={{
                    id: 'quantity',
                    name: 'quantity',
                    startWithCero: true,
                  }}
                />
              </Col>
              <Col>
                <Label className="me-1">Unidad de medida*</Label>
                <Controller
                  name="unitOfMeasure"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        options={measurementUnits}
                      />
                      {errors.unitOfMeasure && (
                        <FormFeedback className="d-block">
                          {errors.unitOfMeasure.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>

              <Col>
                <Label className="me-1">Tipo de venta*</Label>
                <Controller
                  name="TypeOfSale"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        options={filtrarTiposDeVenta(saleTypes)}
                        /*onChange={(e) => {
                            field.onChange(e.value)
                        }}*/
                      />
                      {errors.TypeOfSale && (
                        <FormFeedback className="d-block">
                          {errors.TypeOfSale.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>
            </Row>

            <Row
              className="mx-0"
              style={{
                paddingTop: '2%',
                paddingLeft: '5%',
                marginBottom: '16px',
              }}
            >
              <Col
                sm="4"
                md="4"
              >
                {/* <InputCurrency
                        label={receptor?.dteType?.value === '01' ? "Precio" :  "Precio sin IVA*"}
                        errors={errors}
                        control={control}
                        options={{
                        id: 'price',
                        name: 'price',
                        startWithCero: true,
                        maxLength: filterProps.codeType === 'dui' ? 9 : 14
                        }}
                    /> */}

                <Label className="me-1">
                  {receptor?.dteType?.value === '01'
                    ? 'Precio'
                    : 'Precio sin IVA*'}
                </Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: 'El precio es requerido' }} // Reglas de validación
                  render={({ field: { onChange, value, ref } }) => (
                    <>
                      <CurrencyInput
                        id="input-price"
                        name="price"
                        placeholder="Por favor ingrese un número"
                        value={value} // Valor actual del input
                        decimalsLimit={2}
                        groupSeparator=","
                        decimalSeparator="."
                        prefix="$"
                        className={`form-control ${
                          errors.price ? 'is-invalid' : ''
                        }`} // Aplica estilos de reactstrap
                        onValueChange={(value) => onChange(value)} // Actualiza el valor del formulario
                        inputRef={ref} // Referencia para react-hook-form
                      />
                      {errors.price && (
                        <FormFeedback className="d-block">
                          {errors.price.message}
                        </FormFeedback>
                      )}
                    </>
                  )}
                />
              </Col>
              <Col
                sm="3"
                md="3"
              >
                <InputNumber
                  label={'Porcentaje de descuento'}
                  errors={errors}
                  control={control}
                  type="percent"
                  //disabled={!filterProps.codeType}
                  options={{
                    id: 'discount',
                    name: 'discount',
                    startWithCero: true,
                    maxLength: filterProps.codeType === 'dui' ? 9 : 14,
                  }}
                />
                {errors.discount && (
                  <FormFeedback className="d-block">
                    {errors.discount.message}
                  </FormFeedback>
                )}
              </Col>
              {/* <Col style={{display: "flex", alignItems: "flex-end"}}>
                    <Label check>
                            <Controller
                                name="accept"
                                control={control}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        type="checkbox"
                                        id="acceptCheckbox"
                                        invalid={!!errors.accept}
                                    />
                                )}
                            />{' '}
                            Aplica impuesto
                        </Label>
                    </Col> */}
            </Row>

            {invoiceIssuance?.receptor?.dteType?.value !== '08' && (
              <Row
                className="mx-0"
                style={{ paddingLeft: '5%' }}
              >
                <Col className="d-flex align-items-left justify-content-sm-left my-3">
                  <Button
                    style={{ size: '10px', width: '200px' }}
                    color="primary"
                    type="submit"
                    //onClick={handleClearFilters}
                  >
                    Añadir
                  </Button>
                </Col>
                <Col className="d-flex align-items-center justify-content-end my-3">
                  <Button
                    style={{ size: '10px', width: '200px' }}
                    color="primary"
                    onClick={handleSetProductService}
                  >
                    {isEdited ? 'Editar' : 'Crear'}
                  </Button>
                </Col>
                {isEdited && (
                  <Col className="d-flex align-items-center justify-content-end my-3">
                    <Button
                      style={{ size: '10px', width: '200px' }}
                      type="reset"
                      color="secondary"
                      outline
                      onClick={handleClear}
                    >
                      Limpiar
                    </Button>
                  </Col>
                )}
              </Row>
            )}
          </Card>
        </Form>
      </Fragment>
    )
  }
)

export default CreateProductsForm
